<template></template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "organizations",
  data() {
    return {
      showModal: false,
      organizations: {
        id: "",
        email: "",
        phone: "",
        name: "",
        password: "",
        pAddress: "",
        lAddress: "",
        dirFN: "",
        dirLN: "",
      },
      lastID: 14,
      isActive: false,
      array: [
        {
          id: 1,
          email: "bla@bla.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 2,
          email: "bla@bla1.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 3,
          email: "bla@bla2.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 4,
          email: "bla@bla3.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 5,
          email: "bla@bla4.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 6,
          email: "bla@bla5.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 7,
          email: "bla@bla6.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 8,
          email: "bla@bla7.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 9,
          email: "bla@bla8.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 10,
          email: "bla@bla9.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 11,
          email: "bla@bla10.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 12,
          email: "bla@bla11.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 13,
          email: "bla@bla12.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
        {
          id: 14,
          email: "bla@bla13.ge",
          phone: "5791111111",
          name: "ბლა",
          password: "123",
          pAddress: "სადღაც",
          lAddress: "სადღაც",
          dirFN: "რაღაც",
          dirLN: "რაღაცაძე",
        },
      ],
    };
  },
  validations: {
    organizations: {
      email: {
        required,
        email,
      },
      phone: {
        required,
      },
      name: {
        required,
      },
      password: {
        required,
      },
      pAddress: {
        required,
      },
      lAddress: {
        required,
      },
      dirFN: {
        required,
      },
      dirLN: {
        required,
      },
    },
  },
  methods: {
    addOrganization() {
      this.lastID++;
      this.array.push({
        id: this.lastID,
        email: this.organizations.email,
        phone: this.organizations.phone,
        name: this.organizations.name,
        password: this.organizations.password,
        pAddress: this.organizations.pAddress,
        lAddress: this.organizations.lAddress,
        dirFN: this.organizations.dirFN,
        dirLN: this.organizations.dirLN,
      });
    },
    editOrganization() {
      let editIndex = this.array.findIndex(
        (d) => d.id === this.organizations.id
      );
      this.$set(this.array, editIndex, Object.assign({}, this.organizations));
    },
    deleteOrganization() {
      let deleteIndex = this.array.findIndex(
        (d) => d.id === this.organizations.id
      );
      this.array.splice(deleteIndex, 1);
    },
    editFillInputs(row) {
      this.organizations = Object.assign({}, row);
    },
    getDeleteId(id) {
      this.organizations.id = id;
    },
    clearData() {
      this.organizations.id = null;
      this.organizations.email = "";
      this.organizations.phone = "";
      this.organizations.name = "";
      this.organizations.password = "";
      this.organizations.pAddress = "";
      this.organizations.lAddress = "";
      this.organizations.dirFN = "";
      this.organizations.dirLN = "";
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

.error-border {
  border-color: #ffb3b3;
  box-shadow: none;
}
.editBtn {
  margin-left: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #52af8e;
}
.deleteBtn {
  font-size: 30px;
  cursor: pointer;
  color: #d43f3a;
  margin-left: 10px;
}

.searchBtn {
  font-size: 40px;
  margin-top: -5px;
  cursor: pointer;
  color: #489d7f;
}

.addNewBtn {
  font-size: 44px;
  margin-left: 15px;
  cursor: pointer;
  color: #52af8e;
  margin-top: -5px;
}

@media only screen and (min-width: 1450px) {
  #no-more-tables table {
    border-style: none;
  }
  #no-more-tables th {
    padding: 12px;
    font-weight: bold;
    border-style: none;
    border-bottom: solid #212529 4px;
  }
  #no-more-tables td {
    padding: 10px;
    font-family: "BPGNinoMtavruli";
    border-style: none;
    border-bottom: solid #212529 2px;
  }
}

@media only screen and (max-width: 1450px) {
  .deleteBtn {
    margin-left: 5px;
  }
  #no-more-tables table,
  #no-more-tables thead,
  #no-more-tables tbody,
  #no-more-tables th,
  #no-more-tables td,
  #no-more-tables tr {
    display: block;
    border-style: none;
  }
  #no-more-tables thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  #no-more-tables tr {
    border-bottom: 4px solid #212529;
  }
  #no-more-tables td {
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
    white-space: normal;
    text-align: left;
  }
  #no-more-tables td:before {
    position: absolute;
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
  }
  #no-more-tables td:before {
    content: attr(data-title);
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding-left: 0px;
    padding-right: 0px;
  }
  #no-more-tables table {
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/Loyalty.vue